<div class="trial-plan-current-sub">
  <div class="header">
    <div class="title">10Web free trial</div>
    <div class="subtitle">{{ freeDaysCount }} day{{freeDaysCount > 1 ? 's':''}} for free</div>
  </div>
  <div class="price">$0</div>

  <div class="benefits-list">
    @for (item of benefits; track item.id){
      <div class="item">
        <i class="db-icon db-icon-ds-checkmark-sharp"></i>
        <div class="benefit" [innerHTML]="item.title"></div>
      </div>
    }

  </div>
</div>
